export default __webpack_public_path__ + "static/media/non3.13031868.png";